export enum TestimonialError {
	TEST_ERROR = 'There was an error loading Testimonial. Please try again.',
	DELETE_ERROR = 'Error deleting Testimonial',
	EDIT_ERROR = 'Error editing Testimonial',
	CREATE_ERROR = 'Error creating Testimonial',
}